// angular
import { AfterViewInit, Component, ElementRef, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CoreService } from '../../core/core.service';
import { AppService } from '../../app.service';
import { KlenicoMeService } from '../me.service';
import { MeDynamicReportService } from '../dynamic-report/dynamic-report.service';

@Component({
    selector: 'me-articles',
    templateUrl: './articles.component.html',
    styleUrls: ['./articles.component.scss'],
    providers: [MeDynamicReportService],
    encapsulation: ViewEncapsulation.None
})

export class MeArticlesComponent implements OnInit, AfterViewInit {
    data: any;
    url = 'article/';
    voiceUrl;
    voiceData = '';

    constructor(
        public appService: AppService,
        public elementRef: ElementRef,
        public translate: TranslateService,
        public route: ActivatedRoute,
        public coreService: CoreService,
        public meService: KlenicoMeService,
        public dynamicReportService: MeDynamicReportService,
        public router: Router
    ) {
       
    }

    ngAfterViewInit() {
        this.coreService.className = 'me-landing-page';
    }

    ngOnInit() {
        this.route.paramMap.subscribe((params: ParamMap) => {
            let name = params.get('name');
            this.url = 'article/' + name;
            this.getContent();
        });

        this.translate.onLangChange.subscribe(value => {
            this.voiceUrl = null;
            this.voiceData = '';
            this.getContent();
        });
    }

    getContent() {
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            this.data = res['story']['content'] ?? [];
            let text = this.meService.docToText(this.data.content);
            this.voiceData = this.data.headline + '\n' + text;
            this.appService.isLoading = false;
        }, error => {
            window.alert('Content not found');
            this.appService.isLoading = false;
            this.router.navigate(['me']);
        });
    }

    back() {
        history.back();
    }

    getSpeech() {
        if(this.voiceUrl) {
            return;
        }

        this.dynamicReportService.getSpeech(this.voiceData).subscribe(res => {
            this.voiceUrl = res['url'];
            setTimeout(() => {
                this.elementRef.nativeElement.querySelector('audio').play();
            }, 500)
        });
    }
}
